import { DateFormatter, DateTimeFormatter, NumberFormatter } from '../../components/generics/helper';
import { NUMERIC_DATA_TYPES } from '../../constants/commonConstants';
const Excel = require('exceljs');
var FileSaver = require('file-saver');
const excelExport = {}

excelExport.processExcel = async (config, dataRS) => {
    try {
        const workbook = new Excel.Workbook();
        const worksheet = workbook.addWorksheet(config.workSheetTitle || 'Sheet 1', { headerFooter: { ...config?.headerFooter } });
        worksheet.properties.defaultRowHeight = config?.defaultRowHeight || 16;
        if (config?.pageSetup) {
            worksheet.pageSetup = config.pageSetup;
        }
        if (config?.headerFooter) {
            worksheet.headerFooter.firstHeader = config?.headerFooter?.firstHeader || null;
            worksheet.headerFooter.firstFooter = config?.headerFooter?.firstFooter || null;
            worksheet.headerFooter.evenHeader = config?.headerFooter?.evenHeader || config?.headerFooter?.firstHeader || null;
            worksheet.headerFooter.evenFooter = config?.headerFooter?.evenFooter || config?.headerFooter?.firstFooter || null;
            worksheet.headerFooter.oddHeader = config?.headerFooter?.oddHeader || config?.headerFooter?.firstHeader || null;
            worksheet.headerFooter.oddFooter = config?.headerFooter?.oddFooter || config?.headerFooter?.firstFooter || null;
        }
        if (config?.sheetHeaderData && Array.isArray(config.sheetHeaderData) && config.sheetHeaderData.length > 0) {
            if (Array.isArray(config?.sheetHeaderData)) {
                let addedRow = worksheet.addRow([]);
                let prevColSpan = 0;
                config.sheetHeaderData.forEach((sheetHeadingObj, index) => {
                    let cellValue = '';
                    if (sheetHeadingObj.hasOwnProperty('caption'))
                        cellValue += sheetHeadingObj.caption;
                    if (sheetHeadingObj.hasOwnProperty('value'))
                        cellValue += ' ' + sheetHeadingObj.value;
                    let cell = addedRow.getCell(prevColSpan + 1);
                    cell.value = cellValue;
                    cell.alignment = { vertical: 'middle', horizontal: 'left' };
                    cell.font = { bold: true, size: 14 };
                    cell.border = config.borderStyle;
                    if (sheetHeadingObj.hasOwnProperty('colSpan')) {
                        const currentRowIdx = worksheet.rowCount;
                        const startColSpanIndex = prevColSpan + 1;
                        const endColSpanIndex = startColSpanIndex + sheetHeadingObj.colSpan - 1;
                        worksheet.mergeCells(currentRowIdx, startColSpanIndex, currentRowIdx, endColSpanIndex);
                        prevColSpan = endColSpanIndex;
                    }
                });
                addedRow.commit();
                addedRow = worksheet.addRow([]);
                addedRow.commit();
            }
        }
        // If Report Filter Section To Be Added
        if (config.showFilterSection) {
            if (config?.filterSectionData) {
                const filterData = config?.filterSectionData?.filterData || [];
                const filterHeaderStyle = config?.filterSectionData?.filterHeaderXlStyle || {};
                const filterDataStyle = config?.filterSectionData?.filterHeaderXlDataStyle || {};
                if (Array.isArray(filterData)) {
                    filterData.forEach((dataObj, index) => {
                        let addedRow = worksheet.addRow([]);
                        // Filters Header Row
                        if (dataObj?.columns) {
                            if (Array.isArray(dataObj.columns)) {
                                let prevColSpan = 0;
                                dataObj.columns.forEach((col, index) => {
                                    if (col?.header) {
                                        let cell = addedRow.getCell(prevColSpan + 1);
                                        cell.value = col.header;
                                        if (filterHeaderStyle?.alignment)
                                            cell.alignment = filterHeaderStyle.alignment;
                                        if (filterHeaderStyle?.font)
                                            cell.font = filterHeaderStyle.font;
                                        if (filterHeaderStyle?.fill)
                                            cell.fill = filterHeaderStyle.fill;
                                        cell.border = config.borderStyle;
                                        if (col?.xlCol?.colSpan) {
                                            const currentRowIdx = worksheet.rowCount;
                                            const startColSpanIndex = prevColSpan + 1;
                                            const endColSpanIndex = startColSpanIndex + col.xlCol.colSpan - 1;
                                            worksheet.mergeCells(currentRowIdx, startColSpanIndex, currentRowIdx, endColSpanIndex);
                                            prevColSpan = endColSpanIndex;
                                        }
                                    }
                                });
                            }
                        }
                        addedRow.height = filterHeaderStyle?.defaultRowHeight || 24;
                        addedRow.commit();
                        // Filters Data Row
                        if (dataObj?.columns && dataObj.data) {
                            let addedRow = worksheet.addRow([]);
                            const filterRowData = dataObj.data[0];
                            if (Array.isArray(dataObj.columns)) {
                                let prevColSpan = 0;
                                dataObj.columns.forEach((col, index) => {
                                    if (col?.dataKey) {
                                        let cell = addedRow.getCell(prevColSpan + 1);
                                        if (filterRowData.hasOwnProperty(col.dataKey))
                                            cell.value = filterRowData[col.dataKey];
                                        else
                                            cell.value = '';

                                        if (filterDataStyle?.alignment)
                                            cell.alignment = filterDataStyle.alignment;
                                        if (filterDataStyle?.font)
                                            cell.font = filterDataStyle.font;
                                        if (filterDataStyle?.fill)
                                            cell.fill = filterDataStyle.fill;
                                        cell.border = config.borderStyle;
                                        if (col?.xlCol?.colSpan) {
                                            const currentRowIdx = worksheet.rowCount;
                                            const startColSpanIndex = prevColSpan + 1;
                                            const endColSpanIndex = startColSpanIndex + col.xlCol.colSpan - 1;
                                            worksheet.mergeCells(currentRowIdx, startColSpanIndex, currentRowIdx, endColSpanIndex);
                                            prevColSpan = endColSpanIndex;
                                        }
                                    }
                                });
                            }
                            addedRow.height = filterDataStyle?.defaultRowHeight || 24;
                            addedRow.commit();
                        }
                    });
                }
            }
            // Empty Row After Filter Seciton
            const addedRow = worksheet.addRow([]);
            addedRow.commit();
        }

        if (Array.isArray(config.columns) && config.columns.length > 0) {
            // let row = [];
            let addedRow = worksheet.addRow([]);
            config.columns.forEach((col, index) => {
                if (col.hasOwnProperty('colHeader')) {
                    let cell = addedRow.getCell(index + 1);
                    cell.value = col.colHeader;
                    if (config?.headerRowStyle?.font)
                        cell.font = config.headerRowStyle.font;
                    if (config?.headerRowStyle?.fill)
                        cell.fill = config.headerRowStyle.fill;

                    cell.border = config.borderStyle;
                    if (col.hasOwnProperty('xlCol')) {
                        if (col.xlCol.hasOwnProperty('dataType') && col.xlCol.dataType !== '') {
                            if (NUMERIC_DATA_TYPES.indexOf(col.xlCol.dataType) !== -1) {
                                cell.alignment = { vertical: 'middle', horizontal: 'right' };
                            } else {
                                cell.alignment = { vertical: 'middle', horizontal: 'left' };
                            }
                        }
                        if (col.xlCol.hasOwnProperty('width') && col.xlCol.width > 0) {
                            let column = worksheet.getColumn(index + 1);
                            column.width = col.xlCol.width;
                        }
                    }
                }
            });
            addedRow.height = config?.defaultHeaderRowHeight || 20;
            addedRow.commit();
        }
        if (Array.isArray(config.columns) && config.columns.length > 0 && dataRS.length > 0) {
            for (let data of dataRS) {
                let addedRow = null;
                if (data.isDataRow) {
                    addedRow = worksheet.addRow([]);
                    config.columns.forEach((col, index) => {
                        let cell = addedRow.getCell(index + 1);
                        if (col.hasOwnProperty('field')) {
                            if (data.hasOwnProperty(col.field)) {
                                cell.value = data[col.field];
                                if (col.hasOwnProperty('xlCol')) {
                                    if (col.xlCol.hasOwnProperty('dataType') && col.xlCol.dataType !== '') {
                                        if (NUMERIC_DATA_TYPES.indexOf(col.xlCol.dataType) !== -1) {
                                            if (col.xlCol.dataType === 'currency' || col.xlCol.dataType === 'number') {
                                                cell.value = NumberFormatter(data[col.field], 2);                                                
                                                cell.numFmt = "0.00";
                                            }
                                            if (col.xlCol.dataType === 'quantity') {
                                                cell.value = NumberFormatter(data[col.field], 3);
                                                cell.numFmt = "0.000";
                                            }
                                            cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                        } else {
                                            cell.alignment = { vertical: 'middle', horizontal: 'left' };
                                        }
                                    }
                                    if (col.xlCol.dataType === 'date') {
                                        cell.value = DateFormatter(data[col.field]);
                                    }
                                    if (col.xlCol.dataType === 'dateTime') {
                                        cell.value = DateTimeFormatter(data[col.field]);
                                    }
                                }
                            } else {
                                cell.value = '';
                            }
                            cell.border = config.borderStyle;
                        }
                    });
                } else if (data.isSubHeadingRow) {
                    if (Array.isArray(data?.subHeadingData)) {
                        let addedRow = worksheet.addRow([]);
                        let prevColSpan = 0;
                        data.subHeadingData.forEach((subHeadingObj, index) => {
                            let cellValue = '';
                            if (subHeadingObj.hasOwnProperty('caption'))
                                cellValue += subHeadingObj.caption;
                            if (subHeadingObj.hasOwnProperty('value'))
                                cellValue += ' ' + subHeadingObj.value;
                            let cell = addedRow.getCell(prevColSpan + 1);
                            cell.value = cellValue;
                            cell.alignment = { vertical: 'middle', horizontal: `${subHeadingObj.align || 'left'}` };
                            cell.font = { bold: true };
                            if (data?.rowColor?.argb) {
                                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: data.rowColor.argb }, bgColor: { argb: '000000' } };
                            }
                            cell.border = config.borderStyle;
                            if (subHeadingObj.hasOwnProperty('colSpan')) {
                                const currentRowIdx = worksheet.rowCount;
                                const startColSpanIndex = prevColSpan + 1;
                                const endColSpanIndex = startColSpanIndex + subHeadingObj.colSpan - 1;
                                worksheet.mergeCells(currentRowIdx, startColSpanIndex, currentRowIdx, endColSpanIndex);
                                prevColSpan = startColSpanIndex + subHeadingObj.colSpan - 1;
                            }
                        });
                    }
                } else if (data.isTotalRow) {
                    let addedRow = worksheet.addRow([]);
                    config.columns.forEach((col, index) => {
                        let cell = addedRow.getCell(index + 1);
                        if (col.hasOwnProperty('field')) {
                            if (data.hasOwnProperty(col.field)) {
                                if (NUMERIC_DATA_TYPES.indexOf(col.xlCol.dataType) !== -1) {
                                    if (col.xlCol.dataType === 'currency')
                                        cell.value = NumberFormatter(data[col.field], 2);
                                    if (col.xlCol.dataType === 'quantity')
                                        cell.value = NumberFormatter(data[col.field], 3);
                                    if (col.xlCol.dataType === 'number')
                                        cell.value = data[col.field];
                                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                } else {
                                    cell.value = data[col.field];
                                    cell.alignment = { vertical: 'middle', horizontal: 'left' };
                                }
                            }
                        }
                        if (data?.rowColor?.argb) {
                            let cell = addedRow.getCell(index + 1);
                            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: data.rowColor.argb }, bgColor: { argb: '000000' } };
                            cell.border = config.borderStyle;
                            cell.font = { bold: true };
                        }
                    });
                    let cell = addedRow.getCell(1);
                    cell.value = data.totalCaption;
                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                    if (data.hasOwnProperty('colSpan')) {
                        const currentRowIdx = worksheet.rowCount;
                        worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, data.colSpan);
                    }
                } else if (data.isNoDataRow) {
                    let addedRow = worksheet.addRow([]);
                    let cell = addedRow.getCell(1);
                    cell.value = data.rowCaption;
                    cell.alignment = { vertical: 'middle', horizontal: 'left' };
                    cell.font = { color: { argb: "ffff0000" } };
                    const currentRowIdx = worksheet.rowCount;
                    worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, config.columns.length);
                }
                if (addedRow) {
                    if (config.hasOwnProperty('dataRowStyle')) {
                        if (config.dataRowStyle.hasOwnProperty('font')) {
                            addedRow.font = config.dataRowStyle.font;
                        }
                    }
                    addedRow.height = config?.defaultDataRowHeight || 16;
                    addedRow.commit();
                }
            }

            applyRowSpanMerges(worksheet, dataRS);
        }
        function applyRowSpanMerges(worksheet, dataRS) {
            let headerOffset = worksheet.rowCount - dataRS.length + 1;
            dataRS.forEach((row, i) => {
                if (row.isDataRow && row.rowSpan > 1 && Array.isArray(row.rowSpanColumns)) {
                    const startRow = headerOffset + i;
                    row.rowSpanColumns.forEach(c => {
                        worksheet.mergeCells(startRow, c, startRow + row.rowSpan - 1, c);
                    });
                }
            });
        }

        const fileName = `${config.fileName || 'Xl_Export.xlsx'}`;
        const blobType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], { type: blobType });
            FileSaver.saveAs(blob, fileName);
            // resolve(fileName);
        }, (err) => {
            // reject(err);
            throw err;
        });
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export default excelExport;